<template>
    <nav
        v-if="crumbs && crumbs.length"
        aria-label="Breadcrumb"
        class="mt-4 mb-0 lg:mb-4 mx-8"
    >
        <ol class="list-none p-0 inline-flex text-xs">
            <li
                v-for="(item, index) in crumbs"
                :key="index"
                class="flex items-center"
            >
                <template v-if="item.href">
                    <nuxt-link
                        :to="localePath(item.href)"
                        class="text-black hover:underline"
                    >
                        {{ item.text }}
                    </nuxt-link>
                </template>
                <template v-else>
                    <span>{{ item.text }}</span>
                </template>
                <span
                    v-if="index < crumbs.length - 1"
                    class="mx-2 text-gray-400"
                    >|</span
                >
            </li>
        </ol>
    </nav>
</template>

<script lang="ts" setup>
const { crumbs } = useBreadcrumbs();
const localePath = useLocalePath();
</script>
